import { useEffect, useMemo, useRef } from 'react';
import { styled } from '@mui/material/styles';
import Title from '../../components/Title';
import { useDispatch, useSelector } from 'react-redux';
import { selectCities } from '../../redux/slices/citiesSlice';
import { selectAdmins } from '../../redux/slices/adminsSlice';
import { createModalAlertAsync, deleteModalAlertAsync, getModalAlertsAsync, ModalAlertData, selectModalAlerts, updateModalAlertAsync } from '../../redux/slices/mobileAppModalAlertSlice';
import ModalAlertSettingsModal, { ModalAlertSettingsModalHandles } from './components/MobileAppModalAlertSettingsModal';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ModalAlertTable from './components/ModalAlertTable';
import TableNoItems from '../RewardsPage/TableNoItems';

const PREFIX = 'RewardsPage';

const classes = {
  header: `${PREFIX}-header`,
  addButton: `${PREFIX}-addButton`,
  tableContainer: `${PREFIX}-tableContainer`
};

const Root = styled('div')({
  [`& .${classes.header}`]: {
    display: 'flex',
    alignItems: 'center'
  },
  [`& .${classes.addButton}`]: {
    marginLeft: 30
  },
  [`& .${classes.tableContainer}`]: {
    marginTop: 40
  }
});

const MobileAppModalAlertSettingsPage = () => {
  const dispatch = useDispatch();

  const { items, loading } = useSelector(selectModalAlerts);

  const modalRef = useRef<ModalAlertSettingsModalHandles>(null);

  useEffect(() => {
    dispatch(getModalAlertsAsync());
  }, []);

  const cities = useSelector(selectCities);
  const adminInfo = useSelector(selectAdmins);

  const cityId = useMemo(() => {
    const city = cities.items.find(item => item._id === adminInfo.currentCity);
    if (city) {
      return city._id;
    }
  }, [adminInfo.currentCity, cities.items]);

  const handleAdd = () => {
    modalRef.current?.openAddModal();
  };

  const handleEdit = (item: ModalAlertData) => {
    modalRef.current?.openEditModal(item);
  };

  const handleSave = (
    values: ModalAlertData,
    photo?: string | File,
    isEditMode?: boolean
  ) => {
    if (isEditMode) {
      dispatch(updateModalAlertAsync(values, photo));
    } else {
      dispatch(createModalAlertAsync(values, photo));
    }
  };

  if (!cityId) {
    return null;
  }

  return (
    <Root>
      <div className={classes.header}>
        <Title>Модальне сповіщення</Title>

        <Button
          className={classes.addButton}
          color='primary'
          startIcon={<AddIcon />}
          variant='text'
          onClick={() => handleAdd()}
        >
          Додати
        </Button>
      </div>

      {!items?.length ? (
        <TableNoItems />
      ) : null}

      {items?.length ? (
        <div className={classes.tableContainer}>
          <ModalAlertTable
            items={items}
            openDialog={handleEdit}
            onDelete={(id) => dispatch(deleteModalAlertAsync(id))}
          />
        </div>
      ) : null}

      <ModalAlertSettingsModal ref={modalRef} onSave={handleSave} />
    </Root>
  );
};

export default MobileAppModalAlertSettingsPage;
